module.exports = __webpack_public_path__ + "static/media/Degular-Light.d4671b4b.ttf";